import { refreshProductInfo } from "../modules/Utils/loadProductInfo";

document.addEventListener('DOMContentLoaded', function() {
    const swiperClients = new Swiper('.swiper-clients', {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 48,
        loop: true,
        speed: 800,
        cssMode: true,

        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        navigation: {
            prevEl: '.clients-section .arrow-prev',
            nextEl: '.clients-section .arrow-next',
        }
    })
});

document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.products--cards');
    const filtersOrder = document.querySelector('#asideOrder');
    const filtersCategory = document.querySelector('#asideCategory');
    const perPageDropdown = document.querySelector('#dropdownProductsFilter');
    const searchForm = document.querySelector('.search');
    const searchInput = document.querySelector('#searchInput');
    let currentPerPage = 24;

    const loader = document.createElement('div');
    loader.className = 'products-loader';
    loader.innerHTML = '<div class="spinner"></div>';
    loader.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        display: none;
        justify-content: center;
        align-items: center;
        z-index: 10;
    `;
    
    const spinnerStyle = document.createElement('style');
    spinnerStyle.textContent = `
        .products-loader .spinner {
            width: 50px;
            height: 50px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #3498db;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;
    document.head.appendChild(spinnerStyle);
    container.style.position = 'relative';
    container.appendChild(loader);

    function showLoader() {
        loader.style.display = 'flex';
    }

    function hideLoader() {
        loader.style.display = 'none';
    }

    // Função principal de carregamento AJAX
    function loadProducts(page = 1) {
        showLoader();
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        // 🧩 Ordenação
        const checkedOrder = document.querySelector('input[filter-type="order"]:checked');
        let orderBy = 'sort_order';
        let direction = 'asc';

        if (checkedOrder) {
            switch (checkedOrder.value) {
                case 'oferta':
                    orderBy = 'oferta';
                    break;
                case 'lancamento':
                    orderBy = 'lancamento';
                break;
                case 'mais_vendido':
                    orderBy = 'mais_vendido';
                break;
                case 'by-code':
                    orderBy = 'code';
                    break;
                case 'sort-desc':
                    orderBy = 'title';
                    direction = 'desc';
                    break;
                case 'sort-asc':
                    orderBy = 'title';
                    direction = 'asc';
                    break;
            }
        }

        // Categorias selecionadas
        const selectedCategories = Array.from(document.querySelectorAll('[id^="category_"]:checked'))
            .map(chk => chk.getAttribute('categoryCode'));

        if (selectedCategories.length > 0) {
            params.set('categories', selectedCategories.join(','));
        } else {
            params.delete('categories');
        }

        // 🔍 Busca
        const search = searchInput.value.trim();
        if (search) params.set('search', search);
        else params.delete('search');

        // Paginação e configs
        params.set('page', page);
        params.set('order_by', orderBy);
        params.set('direction', direction);
        params.set('per_page', currentPerPage);

        // Requisição AJAX
        fetch(`${url.pathname}?${params.toString()}`, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(data => {
            const productRow = container.querySelector('.row');
            productRow.innerHTML = data.html;
            container.querySelector('.products--bottom').innerHTML = data.pagination;
            
            attachPaginationEvents();
            
            refreshProductInfo(productRow);
            
            hideLoader();
            const breadcrumb = document.querySelector('.breadcrumb');
            breadcrumb.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(err => console.error('Erro ao carregar produtos:', err));
    }

    // Apenas um checkbox "order" pode ficar marcado
    document.querySelectorAll('input[filter-type="order"]').forEach(chk => {
        chk.addEventListener('change', e => {
            if (e.target.checked) {
                document.querySelectorAll('input[filter-type="order"]').forEach(other => {
                    if (other !== e.target) other.checked = false;
                });
            }
            loadProducts(1);
        });
    });

    // 🔗 Reanexa eventos de paginação
    function attachPaginationEvents() {
        document.querySelectorAll('.pagination button[data-page]').forEach(btn => {
            btn.addEventListener('click', e => {
                const page = e.currentTarget.getAttribute('data-page');
                if (page) loadProducts(page);
            });
        });
    }

    // Impede reload ao enviar busca
    searchForm.addEventListener('submit', e => {
        e.preventDefault();
        loadProducts(1);
    });

    // Impede Enter de recarregar
    searchInput.addEventListener('keydown', e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            loadProducts(1);
        }
    });

    // Filtro por categoria
    filtersCategory.querySelectorAll('input[type="checkbox"]').forEach(chk => {
        chk.addEventListener('change', () => loadProducts(1));
    });

    // Dropdown de "X itens"
    document.querySelectorAll('.dropdown-menu .dropdown-item').forEach(item => {
        item.addEventListener('click', e => {
            const perPageValue = e.currentTarget.getAttribute('perPage');
            currentPerPage = parseInt(perPageValue) || 9;
            perPageDropdown.innerText = `${currentPerPage} itens`;
            loadProducts(1);
        });
    });

    // Inicializa
    attachPaginationEvents();
    refreshProductInfo(container);
});